import React, { useMemo } from 'react';
import { styles } from '@sdir/sds';
import styled from 'styled-components';
import { GenericTileStatus } from '../../../types';

type CertificateStatusFieldProps = {
  certificateStatusName: string;
  certificateStatus: GenericTileStatus;
};

const CertificateStatusField: React.FC<CertificateStatusFieldProps> = ({
  certificateStatusName,
  certificateStatus,
}) => {
  const iconColor = useMemo(() => {
    switch (certificateStatus) {
      case GenericTileStatus.Started:
        return styles.colors.primaryLightBlue2;
      case GenericTileStatus.Incomplete:
        return styles.colors.alert.warningDark;
      case GenericTileStatus.Rejected:
        return styles.colors.alert.errorDark;
      case GenericTileStatus.Handling:
        return styles.colors.alert.warningDark;
      case GenericTileStatus.Valid:
        return styles.colors.alert.successDark;
      default:
        return styles.colors.alert.errorDark;
    }
  }, [certificateStatus]);
  return (
    <StatusBody>
      <Dot color={iconColor} />
      <p>{certificateStatusName}</p>
    </StatusBody>
  );
};

const Dot = styled.span<{ color: string }>`
  background-color: ${({ color }) => color};
  display: block;
  height: 16px;
  width: 8px;
  border-radius: 4px;
`;

const StatusBody = styled.div`
  display: flex;
  column-gap: 0.5em;
  align-items: center;
  p {
    font-weight: bold;
    margin: 0;
    line-height: 1.1;
  }
`;

export default CertificateStatusField;
